// assets/recipe-filter.js
// <recipe-filter> — instant client-side filtering of recipe cards by article tag.
// Single-select chip toggle: pick a chip to show only recipes carrying its tag;
// click the active chip again to clear. Each card exposes its tags via data-tags
// (lowercase, comma-separated). Progressive enhancement — with JS off, every card
// renders and chips are inert.
if (!customElements.get("recipe-filter")) {
  customElements.define(
    "recipe-filter",
    class RecipeFilter extends HTMLElement {
      connectedCallback() {
        this.chips = [...this.querySelectorAll("[data-recipe-chip]")];
        this.cards = [...this.querySelectorAll("[data-tags]")];
        this.empty = this.querySelector("[data-recipe-empty]");
        this.activeTag = null;

        this.onChipClick = this.onChipClick.bind(this);
        this.chips.forEach((chip) => chip.addEventListener("click", this.onChipClick));

        // Honour a chip marked "selected by default" (first one wins).
        const defaultChip = this.chips.find((c) => c.dataset.default === "true");
        if (defaultChip) {
          this.activeTag = (defaultChip.dataset.tag || "").trim();
          this.syncChips();
          this.apply();
        }
      }

      disconnectedCallback() {
        this.chips?.forEach((chip) => chip.removeEventListener("click", this.onChipClick));
      }

      onChipClick(event) {
        const chip = event.currentTarget;
        const tag = (chip.dataset.tag || "").trim();
        // Re-clicking the active chip clears the filter; otherwise select it.
        this.activeTag = this.activeTag === tag ? null : tag;
        this.syncChips();
        this.apply();
      }

      syncChips() {
        this.chips.forEach((c) =>
          c.setAttribute("aria-pressed", (c.dataset.tag || "").trim() === this.activeTag ? "true" : "false")
        );
      }

      apply() {
        let visible = 0;
        this.cards.forEach((card) => {
          const tags = (card.dataset.tags || "").split(",").map((t) => t.trim());
          const show = this.activeTag === null || tags.includes(this.activeTag);
          card.classList.toggle("hidden", !show);
          if (show) visible += 1;
        });

        const noneVisible = visible === 0 && this.activeTag !== null;
        this.empty?.classList.toggle("hidden", !noneVisible);
      }
    }
  );
}
